module.exports = __webpack_public_path__ + "static/img/sanwei-3.fbcc55dc.png";